module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep4@2x-be11e718e33663e25f4b691c71a76831.png";